<template>
  <div class="riattivazioni-ko-table">
    <!-- Header con contatore -->
    <div class="table-toggle-header" @click="aperta = !aperta">
      <div class="flex align-items-center gap-3">
        <i class="pi pi-exclamation-triangle" style="color: #f44336; font-size: 1.5rem;"></i>
        <h5 class="m-0 ml-2">Riattivazioni in KO</h5>
      </div>
      <div class="flex align-items-center gap-2">
        <Tag :value="`${recordKO.length} record`" severity="danger"></Tag>
        <Button :icon="aperta ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" class="p-button-text p-button-rounded" />
      </div>
    </div>

    <!-- Contenuto tabella collassabile -->
    <transition name="expand">
      <div v-show="aperta" class="table-content">
        <!-- Pannello Filtri Collapsabile -->
        <transition name="expand">
          <div v-show="mostraFiltri" class="filtri-panel mb-3">
            <div class="filtri-grid">
              <div class="p-field">
                <label for="filter-cp-utente">CP Utente</label>
                <InputText id="filter-cp-utente" v-model="filters.cp_utente.value" placeholder="Filtra per CP Utente"
                  class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-pod">POD</label>
                <InputText id="filter-pod" v-model="filters.cod_pod.value" placeholder="Filtra per POD"
                  class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-piva-utente">P.IVA Utente</label>
                <InputText id="filter-piva-utente" v-model="filters.piva_utente.value"
                  placeholder="Filtra per P.IVA Utente" class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-piva-gestore">P.IVA Gestore</label>
                <InputText id="filter-piva-gestore" v-model="filters.piva_gestore.value"
                  placeholder="Filtra per P.IVA Gestore" class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-causale">Causale</label>
                <InputText id="filter-causale" v-model="filters.cod_causale.value" placeholder="Filtra per causale"
                  class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-motivazione">Motivazione</label>
                <InputText id="filter-motivazione" v-model="filters.motivazione.value"
                  placeholder="Filtra per motivazione" class="w-full" />
              </div>
            </div>
            <div class="flex justify-content-end gap-2 mt-3">
              <Button label="Reset Filtri" icon="pi pi-filter-slash" class="p-button-outlined p-button-sm"
                @click="resetFiltri" />
            </div>
          </div>
        </transition>

        <DataTable :value="recordConId" :loading="loading" paginator :rows="10" :rowsPerPageOptions="[10, 25, 50]"
          responsiveLayout="scroll" stripedRows v-model:filters="filters" v-model:selection="recordSelezionati"
          dataKey="_uniqueId">
          <template #header>
            <div class="table-header-custom">
              <div class="flex align-items-center" style="gap: 0.5rem;">
                <Button label="Aggiorna" icon="pi pi-refresh" class="p-button-outlined p-button-sm"
                  @click="$emit('refresh')" :loading="loading" />
                <Button label="Filtri" :icon="mostraFiltri ? 'pi pi-filter-fill' : 'pi pi-filter'"
                  :class="['p-button-outlined p-button-sm', mostraFiltri ? 'p-button-primary' : '']"
                  @click="mostraFiltri = !mostraFiltri" />
                <Button label="Scarica Selezionati" icon="pi pi-download" class="p-button-success p-button-sm"
                  @click="handleScaricaSelezionati" :disabled="!recordSelezionati || recordSelezionati.length === 0" />
                <transition name="fade">
                  <Tag v-if="recordSelezionati && recordSelezionati.length > 0"
                    :value="`${recordSelezionati.length} selezionati`" severity="info" class="selection-badge" />
                </transition>
              </div>
              <div class="search-box">
                <i class="pi pi-search"></i>
                <InputText v-model="ricercaGlobale" placeholder="Ricerca globale..." class="p-inputtext-sm" />
                <Button v-if="ricercaGlobale" icon="pi pi-times" class="p-button-text p-button-sm p-button-rounded"
                  @click="cancellaRicerca" />
              </div>
            </div>
          </template>

          <Column selectionMode="multiple" headerStyle="width: 3rem" :exportable="false"></Column>

          <Column field="cp_utente" header="CP Utente" sortable style="min-width: 150px;"></Column>
          <Column field="cod_pod" header="POD" sortable style="min-width: 150px;"></Column>
          <Column field="piva_utente" header="P.IVA Utente" sortable style="min-width: 130px;"></Column>
          <Column field="piva_gestore" header="P.IVA Gestore" sortable style="min-width: 130px;"></Column>
          <Column field="cod_causale" header="Causale" sortable style="min-width: 100px;">
            <template #body="slotProps">
              <Tag severity="warning" :value="slotProps.data.cod_causale"></Tag>
            </template>
          </Column>
          <Column field="motivazione" header="Motivazione" style="min-width: 350px;">
            <template #body="slotProps">
              <span class="motivazione-text motivazione-error" :title="slotProps.data.motivazione">
                {{ slotProps.data.motivazione }}
              </span>
            </template>
          </Column>
          <Column field="data_invio" header="Data Invio" sortable style="min-width: 120px;">
            <template #body="slotProps">
              {{ formatDate(slotProps.data.data_invio) }}
            </template>
          </Column>
          <Column header="Stato" sortable style="min-width: 120px;">
            <template #body>
              <Tag severity="danger" value="KO"></Tag>
            </template>
          </Column>
          <Column header="Azioni" :style="{ width: '140px', textAlign: 'center' }">
            <template #body="slotProps">
              <div class="action-button-wrapper">
                <Button icon="pi pi-pencil" class="p-button-warning action-btn"
                  @click="$emit('revisiona', slotProps.data)" v-tooltip.top="'Revisiona e Reinvia'" />
                <Button icon="pi pi-check" class="p-button-success action-btn ml-2"
                  @click="$emit('valida', slotProps.data)" v-tooltip.top="'Valida KO'" />
              </div>
            </template>
          </Column>

          <template #empty>
            <div class="text-center p-4">
              <i class="pi pi-check-circle" style="font-size: 3rem; color: #4CAF50;"></i>
              <p class="mt-3">Nessun record in KO per le riattivazioni</p>
            </div>
          </template>
        </DataTable>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, computed, defineComponent, watch } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';

export default defineComponent({
  name: 'RiattivazioniKOTable',
  props: {
    recordKO: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['refresh', 'revisiona', 'valida', 'scarica'],
  setup(props, { emit }) {
    const toast = useToast();

    // State
    const aperta = ref(false);
    const mostraFiltri = ref(false);
    const ricercaGlobale = ref('');
    const recordSelezionati = ref([]);

    // Filtri
    const filters = ref({
      cp_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
      cod_pod: { value: null, matchMode: FilterMatchMode.CONTAINS },
      piva_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
      piva_gestore: { value: null, matchMode: FilterMatchMode.CONTAINS },
      cod_causale: { value: null, matchMode: FilterMatchMode.CONTAINS },
      motivazione: { value: null, matchMode: FilterMatchMode.CONTAINS },
      data_invio: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    // Watch per preservare la selezione quando i dati vengono aggiornati
    watch(() => props.recordKO, (newRecords) => {
      if (recordSelezionati.value.length > 0) {
        // Mantieni i record selezionati che esistono ancora nei nuovi dati
        const newRecordsWithId = newRecords.map((record, index) => ({
          ...record,
          _uniqueId: `${record.cod_pod || ''}_${record.cp_utente || ''}_${record.data_invio || ''}_${index}`
        }));
        
        recordSelezionati.value = recordSelezionati.value.map(selected => {
          const match = newRecordsWithId.find(record => record._uniqueId === selected._uniqueId);
          return match || selected;
        }).filter(selected => 
          newRecordsWithId.some(record => record._uniqueId === selected._uniqueId)
        );
      }
    });

    // Computed
    // Aggiungi un ID univoco a ogni record
    const recordConId = computed(() => {
      let records = props.recordKO;
      
      // Applica ricerca globale se presente
      if (ricercaGlobale.value) {
        const searchTerm = ricercaGlobale.value.toLowerCase();
        const searchableFields = [
          'cp_utente', 'cod_pod', 'piva_utente', 'piva_gestore',
          'cod_causale', 'motivazione'
        ];

        records = records.filter(record =>
          searchableFields.some(field => {
            const value = record[field];
            return value && value.toString().toLowerCase().includes(searchTerm);
          })
        );
      }
      
      // Aggiungi un _uniqueId a ogni record
      return records.map((record, index) => ({
        ...record,
        _uniqueId: `${record.cod_pod || ''}_${record.cp_utente || ''}_${record.data_invio || ''}_${index}`
      }));
    });

    const recordFiltrati = recordConId; // Alias per compatibilità

    // Methods
    const resetFiltri = () => {
      filters.value = {
        cp_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cod_pod: { value: null, matchMode: FilterMatchMode.CONTAINS },
        piva_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
        piva_gestore: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cod_causale: { value: null, matchMode: FilterMatchMode.CONTAINS },
        motivazione: { value: null, matchMode: FilterMatchMode.CONTAINS },
        data_invio: { value: null, matchMode: FilterMatchMode.CONTAINS }
      };
    };

    const cancellaRicerca = () => {
      ricercaGlobale.value = '';
    };

    const formatDate = (dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT');
    };

    const handleScaricaSelezionati = () => {
      if (!recordSelezionati.value || recordSelezionati.value.length === 0) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona almeno un record da scaricare',
          life: 3000
        });
        return;
      }

      // Prepara i dati per il CSV in formato FLUSSO 0050 (formato invio)
      const csvRows = recordSelezionati.value.map(record => {
        return [
          'RT1',                                    // COD_SERVIZIO
          '0050',                                   // COD_FLUSSO (formato invio, non 0100)
          record.piva_utente || '',                 // PIVA_UTENTE
          record.piva_gestore || '',                // PIVA_GESTORE
          record.cp_utente || '',                   // CP_UTENTE
          record.cod_pod || record.pod || '',       // COD_POD (supporta entrambi i nomi)
          record.cod_prestazione || '',             // COD_PRESTAZIONE
          record.cod_contr_disp || '',              // COD_CONTR_DISP
          record.cf || '',                          // CF
          record.piva || '',                        // PIVA
          record.cf_straniero || '',                // CF_STRANIERO
          record.telefono || '',                    // TELEFONO
          record.email || ''                        // EMAIL
        ].join(';');
      });

      // Header CSV (flusso 0050 per riattivazioni - RT1 ha 13 campi)
      const header = 'COD_SERVIZIO;COD_FLUSSO;PIVA_UTENTE;PIVA_GESTORE;CP_UTENTE;COD_POD;COD_PRESTAZIONE;COD_CONTR_DISP;CF;PIVA;CF_STRANIERO;TELEFONO;EMAIL';
      const csvContent = [header, ...csvRows].join('\n');

      // Crea blob e scarica
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `riattivazioni_ko_flusso0050_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.add({
        severity: 'success',
        summary: 'Download completato',
        detail: `${recordSelezionati.value.length} record scaricati in formato flusso 0050 (pronto per reinvio)`,
        life: 3000
      });

      emit('scarica', recordSelezionati.value);
    };

    return {
      aperta,
      mostraFiltri,
      ricercaGlobale,
      recordSelezionati,
      filters,
      recordConId,
      recordFiltrati,
      resetFiltri,
      cancellaRicerca,
      formatDate,
      handleScaricaSelezionati
    };
  }
});
</script>

<style scoped>
/* === CONTAINER PRINCIPALE === */
.riattivazioni-ko-table {
  margin-bottom: 2rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* === HEADER COLLASSABILE === */
.table-toggle-header {
  background: linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%);
  border: 1px solid #fda4af;
  border-radius: 12px;
  padding: 1.5rem 2rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  box-shadow: 0 1px 3px rgba(251, 113, 133, 0.1);
}

.table-toggle-header:hover {
  background: linear-gradient(135deg, #ffe4e6 0%, #fecdd3 100%);
  box-shadow: 0 4px 12px rgba(251, 113, 133, 0.18);
}

.table-toggle-header h5 {
  color: #9f1239;
  font-weight: 700;
  font-size: 1.125rem;
  letter-spacing: -0.01em;
}

.table-toggle-header i {
  filter: drop-shadow(0 2px 4px rgba(251, 113, 133, 0.2));
}

/* === CONTENUTO TABELLA === */
.table-content {
  margin-top: 1rem;
  padding: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-left: 4px solid #fb7185;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

/* === PANNELLO FILTRI === */
.filtri-panel {
  background: #ffffff;
  padding: 2rem;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  margin: 1.5rem;
}

.filtri-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
}

.p-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.p-field label {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.p-field input {
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.p-field input:focus {
  border-color: #6b7280;
  box-shadow: 0 0 0 3px rgba(107, 116, 128, 0.08);
  outline: none;
}

/* === HEADER TABELLA === */
.table-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 1.5rem 1.5rem 1rem;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
}

/* === SEARCH BOX === */
.search-box {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  min-width: 280px;
  flex: 1;
  max-width: 400px;
  transition: all 0.2s ease;
}

.search-box:focus-within {
  background: #ffffff;
  border-color: #9ca3af;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.08);
}

.search-box i.pi-search {
  color: #6b7280;
  font-size: 0.95rem;
}

.search-box .p-inputtext {
  border: none;
  background: transparent;
  box-shadow: none;
  flex: 1;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
}

.search-box .p-inputtext:focus {
  box-shadow: none;
  outline: none;
}

.search-box .p-button {
  margin: 0;
  padding: 0.25rem;
  width: 1.75rem;
  height: 1.75rem;
}

/* === ACTION BUTTONS === */
.action-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.action-btn {
  width: 2.5rem;
  height: 2.5rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

/* === SELECTION BADGE === */
.selection-badge {
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
  border: 1px solid #93c5fd;
}

/* === MOTIVAZIONE TEXT === */
.motivazione-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: help;
  text-align: left;
}

.motivazione-error {
  color: #dc2626;
  font-weight: 600;
  font-size: 0.85rem;
  background: #fef2f2;
  border-left: 3px solid #dc2626;
  padding: 0.75rem 1rem;
  border-radius: 6px;
}

/* === DATA TABLE STYLING === */
:deep(.p-datatable) {
  border-radius: 0;
}

:deep(.p-datatable .p-datatable-header) {
  background: transparent;
  border: none;
  padding: 0;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #374151;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #e5e7eb;
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  transition: none;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb !important;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 1rem;
  text-align: center;
  vertical-align: middle;
  color: #374151;
  font-size: 0.9rem;
  border-bottom: 1px solid #f3f4f6;
}

:deep(.p-datatable .p-datatable-tbody > tr > td:first-child) {
  font-weight: 600;
}

:deep(.p-paginator) {
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
  padding: 1rem;
}

:deep(.p-column-filter) {
  width: 100%;
}

/* === BUTTONS === */
:deep(.p-button-sm) {
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem;
  font-weight: 600;
  border-width: 1px;
}

:deep(.p-inputtext-sm) {
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem;
}

/* === TAG STYLING === */
:deep(.p-tag) {
  font-weight: 600;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
}

/* === ANIMAZIONI === */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
}

.expand-enter-from {
  opacity: 0;
  transform: scaleY(0.95) translateY(-10px);
}

.expand-enter-to {
  opacity: 1;
  transform: scaleY(1) translateY(0);
}

.expand-leave-from {
  opacity: 1;
  transform: scaleY(1) translateY(0);
}

.expand-leave-to {
  opacity: 0;
  transform: scaleY(0.95) translateY(-10px);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* === RESPONSIVE === */
@media (max-width: 1024px) {
  .filtri-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }
}

@media (max-width: 768px) {
  .table-toggle-header {
    padding: 1.25rem 1.5rem;
  }

  .table-header-custom {
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
  }

  .search-box {
    width: 100%;
    min-width: auto;
    max-width: 100%;
  }

  .filtri-panel {
    padding: 1.5rem;
    margin: 1rem;
  }

  .filtri-grid {
    grid-template-columns: 1fr;
  }

  .action-button-wrapper {
    flex-wrap: wrap;
  }
}
</style>
